export default {
      id: "ic-like-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic-like-usage",
      toString: function () {
        return this.url;
      }
    }